import { render, staticRenderFns } from "./xml.vue?vue&type=template&id=c4f4c640&scoped=true&"
import script from "./xml.vue?vue&type=script&lang=ts&"
export * from "./xml.vue?vue&type=script&lang=ts&"
import style1 from "./xml.vue?vue&type=style&index=1&id=c4f4c640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f4c640",
  null
  
)

export default component.exports